import React, { useState, useEffect } from 'react';
import { TextField, Button, TableCell, CircularProgress } from '@material-ui/core';
import useOrderPackages from 'hooks/useOrderPackages';
import { useOrdersContext } from 'contextApi/OrdersContext';
import { downloadPDF } from 'utils/downloadPDF';
import useStyles from 'components/organisms/OrderPackageList/OrderPackageList.styles';
import useCustomSnackbar from 'hooks/useCustomSnackbar';
import { IOrderShippingRequest, IPackages } from 'interfaces/orderPackages.interface';

interface Props {
  orderPackageDetail: IPackages;
  index: number;
  shippingType: string | undefined;
}
export default function OrderPackageForm({ orderPackageDetail, index, shippingType }: Props) {
  const {
    orderPackages,
    setOrderPackages,
    orderPackageShipping,

    handleOpenModalCreateShipping
  } = useOrdersContext();
  const { createPackage, getOrderPackages, createPackageDelivery } = useOrderPackages();
  const { showNotistack } = useCustomSnackbar();
  const [sendPackage, setSendPackage] = useState<boolean>(false);
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const deletePackage = (indexPackage: number) => {
    if (orderPackages.packages) {
      const copyPackages = [...orderPackages.packages];
      copyPackages.splice(indexPackage, 1);

      setOrderPackages({
        packages: copyPackages
      });
    }
  };

  const validateTrackingNumberPackage = () => {
    if (orderPackages.packages) {
      if (orderPackages.packages[index].status) {
        setSendPackage(true);
      } else {
        setSendPackage(false);
      }
    }
  };

  useEffect(() => {
    validateTrackingNumberPackage();
  }, []);

  useEffect(() => {
    validateTrackingNumberPackage();
  }, [orderPackages.packages]);

  const handleOnSubmit = () => {
    setIsLoading(true);
    let specifyPackage: any;
    let arrayPackage: IOrderShippingRequest = {};
    if (shippingType === '2') {
      if (orderPackageShipping.labelId && orderPackageShipping.warehouseId) {
        if (orderPackages.packages) {
          if (orderPackageShipping.packages) {
            specifyPackage = orderPackages.packages[index];
            orderPackageShipping.packages = [specifyPackage];
            arrayPackage = orderPackageShipping;

            createPackage(arrayPackage)
              .then((response) => {
                getOrderPackages(orderPackageShipping.orderId).then((orderPackages) => {
                  setOrderPackages(orderPackages);
                  if (orderPackages.packages && orderPackages.packages?.length < 1) {
                    handleOpenModalCreateShipping(false);
                  }
                });
                downloadPDF(response.pdf, `pedido_${orderPackageShipping.orderId}_guia_${response.trackingId}`);
              })
              .catch((err) => {
                if (err.response?.status === 400 && err.response.data?.message) {
                  showNotistack({ message: err.response.data?.message });
                } else {
                  showNotistack({
                    message: typeof err === 'string' ? err : 'Ocurrió un error, contacta con soporte por favor.'
                  });
                }
              })
              .finally(() => {
                validateTrackingNumberPackage();
                setIsLoading(false);
              });
          }
        }
      } else {
        showNotistack({ message: 'Todos los campos son obligatorios' });
        setIsLoading(false);
        return;
      }
    } else {
      if (orderPackageShipping.labelId && orderPackageShipping.warehouseId) {
        if (orderPackages.packages) {
          if (orderPackageShipping.packages) {
            specifyPackage = orderPackages.packages[index];
            orderPackageShipping.packages = [specifyPackage];
            arrayPackage = orderPackageShipping;

            createPackageDelivery(arrayPackage)
              .then((response) => {
                getOrderPackages(orderPackageShipping.orderId).then((orderPackages) => {
                  setOrderPackages(orderPackages);

                  if (orderPackages.packages && orderPackages.packages?.length < 1) {
                    handleOpenModalCreateShipping(false);
                  }
                });
                downloadPDF(response.pdf, `pedido_${orderPackageShipping.orderId}_guia_${response.trackingId}`);
              })
              .catch((err) => {
                if (err.response?.status === 400 && err.response.data?.message) {
                  showNotistack({ message: err.response.data?.message });
                } else {
                  showNotistack({
                    message: typeof err === 'string' ? err : 'Ocurrió un error, contacta con soporte por favor.'
                  });
                }
              })
              .finally(() => {
                validateTrackingNumberPackage();
                setIsLoading(false);
              });
          }
        }
      } else {
        showNotistack({ message: 'Todos los campos son obligatorios' });
        setIsLoading(false);
        return;
      }
    }
  };

  return (
    <React.Fragment>
      <TableCell className={classes.colorColumn}>
        <TextField
          variant="outlined"
          margin="normal"
          style={{ width: 120 }}
          id={`height ${index}`}
          label="Altura"
          name="height"
          value={orderPackageDetail.height}
          onChange={(e) => {
            if (orderPackages.packages) {
              const orderPackageCopy = [...orderPackages.packages];
              orderPackageCopy[index].height = Number(e.target.value);
              setOrderPackages({
                ...orderPackages,
                packages: orderPackageCopy
              });
            }
          }}
          // disabled={isLoading}
        />
      </TableCell>
      <TableCell className={classes.colorColumn}>
        <TextField
          variant="outlined"
          margin="normal"
          id={` width ${index}`}
          style={{ width: 120 }}
          label="Anchura"
          name="width"
          value={orderPackageDetail.width}
          onChange={(e) => {
            if (orderPackages.packages) {
              const orderPackageCopy = [...orderPackages.packages];
              orderPackageCopy[index].width = Number(e.target.value);
              setOrderPackages({
                ...orderPackages,
                packages: orderPackageCopy
              });
            }
          }}
          // disabled={isLoading}
        />
      </TableCell>
      <TableCell className={classes.colorColumn}>
        <TextField
          variant="outlined"
          margin="normal"
          style={{ width: 120 }}
          id={`length${index}}`}
          label="Longitud"
          name="length"
          value={orderPackageDetail.length}
          onChange={(e) => {
            if (orderPackages.packages) {
              const orderPackageCopy = [...orderPackages.packages];
              orderPackageCopy[index].length = Number(e.target.value);
              setOrderPackages({
                ...orderPackages,
                packages: orderPackageCopy
              });
            }
          }}
          // disabled={isLoading}
        />
      </TableCell>
      <TableCell className={classes.colorColumn}>
        <TextField
          variant="outlined"
          style={{ width: 120 }}
          margin="normal"
          id={`weight${index}`}
          label="Peso"
          name="weight"
          value={orderPackageDetail.weight}
          onChange={(e) => {
            if (orderPackages.packages) {
              const orderPackageCopy = [...orderPackages.packages];
              orderPackageCopy[index].weight = Number(e.target.value);
              setOrderPackages({
                ...orderPackages,
                packages: orderPackageCopy
              });
            }
          }}
        />
      </TableCell>
      <TableCell className={classes.colorColumn} style={{ padding: 3 }}>
        {!sendPackage ? (
          <React.Fragment>
            <Button
              disabled={isLoading || orderPackageDetail?.products?.length === 0}
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => {
                handleOnSubmit();
              }}
            >
              {isLoading ? <CircularProgress size={24} /> : ''} Crear
            </Button>
            {orderPackageDetail.products ? (
              // orderPackageDetail.type === 'D' ||
              // orderPackageDetail.type === 'C' ||
              orderPackageDetail.products.length > 0 ? null : (
                <Button
                  disabled={isLoading}
                  variant="contained"
                  style={{ color: '#FFFF', backgroundColor: '#FF2626', marginLeft: 2 }}
                  onClick={() => {
                    deletePackage(index);
                  }}
                >
                  Eliminar
                </Button>
              )
            ) : null}
          </React.Fragment>
        ) : (
          <Button disabled={isLoading} variant="contained" style={{ background: '#F5F5F5', color: '#C5C5C5' }}>
            {isLoading ? <CircularProgress size={24} /> : ''} Crear
          </Button>
        )}
      </TableCell>
    </React.Fragment>
  );
}
